/**
 */
import { createSelector } from 'reselect';

import getApplication from '/business/shared/state/selectors/application/getApplicationSelector';

import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default createSelector(getApplication, (application) => {
  return application?.permissions || EMPTY_ARRAY;
});
